import { render, staticRenderFns } from "./Considerations.vue?vue&type=template&id=344e9275&scoped=true&"
import script from "./Considerations.vue?vue&type=script&lang=js&"
export * from "./Considerations.vue?vue&type=script&lang=js&"
import style0 from "./Considerations.vue?vue&type=style&index=0&id=344e9275&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344e9275",
  null
  
)

export default component.exports